// jshint module: true

// Enable JS className
document.body.classList.add('has-js');



// WEBPACK FOOTER //
// ./website/assets/scripts/polyfills/enable-js-classname.js